// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Pill{border-radius:.3125rem;font-size:.625rem;font-weight:700;margin-left:1.25rem;padding:.1875rem .625rem;text-align:center;white-space:nowrap}.Pill,.Pill--primary{background:#2d8c00;color:#fff}.Pill--secondary{background:#ff7a00;color:#fff}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
